import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { SensorBatteryStats } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  params: {
    uniqueId: string
  }
  options?: Omit<
    UseQueryOptions<SensorBatteryStats | null, Error>,
    'queryKey' | 'queryFn'
  >
}

export const useSensorBatteryStats = ({
  params,
  options,
}: RequestParams) => {
  const api = useApiInstance()
  const { uniqueId } = params
  return useQuery<SensorBatteryStats | null, Error>(
    [Entities.Sensors, `sensor-battery-stats-${uniqueId}`],
    async () => {
      const { data } = await api.v1AdminSensorsUniqueIdBatteryStatsGet(uniqueId)
      return (data as SensorBatteryStats) ?? null
    },
    { ...options },
  )
}
